import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupPicker, GroupPickerItem } from '../GroupPicker';

interface UserStatusPickerProps {
  value: GroupPickerItem<boolean>[] | null;
  onChange: (value: GroupPickerItem<boolean>[]) => void;
  multiple?: boolean;
}

export function UserStatusPicker(props: UserStatusPickerProps) {
  const { value, onChange, multiple } = props;

  const { t } = useTranslation();

  const groups = useMemo(() => {
    return [
      {
        id: false,
        name: t('COMMON.ACTIVE'),
      },
      {
        id: true,
        name: t('FIELDS.inactive'),
      },
    ];
  }, [t]);

  return (
    <GroupPicker<boolean>
      value={value}
      onChange={onChange}
      groups={groups}
      multiple={multiple}
    />
  );
}
